module.exports = __webpack_public_path__ + "static/media/warning.91c1ecba.svg";